import { Helmet } from "react-helmet-async"

interface SEOHeadProps {
  title: string
  description: string
  ogImage?: string
  ogUrl?: string
  themeColor?: string
}

export function SEOHead({ title, description, ogImage, ogUrl, themeColor }: SEOHeadProps) {
  const url = ogUrl || (typeof window !== "undefined" ? window.location.href : "")

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {themeColor && <meta name="theme-color" content={themeColor} />}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  )
}
